import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Admin } from '../../../admin/models/Admin';
import { AdminService } from '../../../admin/services/AdminService';
import { SessionService  } from '../../../admin/services/SessionService';
import { LocalStorageService  } from '../../../core/services/LocalStorageService';
import { Subscription }   from 'rxjs/Subscription';

@Component({
    selector: 'admin-header-auth',
    template: require('./AdminHeaderAuthComponent.html'),
    styles: [require('./AdminHeaderAuthComponent.sass')]
})

export class AdminHeaderAuthComponent implements OnInit{
    @Input() module: string;
    private headerName: string;
    private subscription: Subscription;
    private adminData: Admin;
    private sidebarStatus: boolean;
	private hostName: string;
    private errorMessage: string;
    // For logout navigate
    protected devEnv: any = ['auth.eca.dev.nascorp.vn','camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn', 'conference.eca.dev.nascorp.vn'];
    protected testEnv: any = ['auth.eca.test.nascorp.vn','camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn', 'conference.eca.test.nascorp.vn'];
    protected stagingEnv: any = ['auth.eca.uat.nascorp.vn','services.eca.uat.nascorp.vn','asa.eca.uat.nascorp.vn','holidayschool.eca.uat.nascorp.vn','bus.eca.uat.nascorp.vn','outdooreducation.eca.uat.nascorp.vn','reen.eca.uat.nascorp.vn','acs.eca.uat.nascorp.vn','pcbs.eca.uat.nascorp.vn'];
    protected procEnv: any = ['auth.aisvietnam.com','outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com', 'pcbs.aisvietnam.com']

    constructor(
        private adminService: AdminService,
        private sessionService: SessionService,
        private router: Router,
    ) { }

    ngOnInit() {
        this.getSession();
        this.hostName = window.location.hostname;
        this.headerName = this.getHeaderName(this.module);

        this.subscription = this.adminService.adminDataChanged$.subscribe(
            admin => {
                this.onSessionChanged(admin);
            }
        );
        // Get Admin session
        this.adminData = this.adminService.getAdminSessionData();
    }

    ngOnDestroy() {
        // Destroy the subscription for session changes
        this.subscription.unsubscribe();
    } 

    private onSessionChanged(admin: Admin) {
        //TO DO: update menu content when session changed
        this.adminData = admin;
        this.sidebarStatus = this.getSidebarStatus();
    }

    private getSession() : void{
        this.sessionService.getSession()
            .subscribe(
                admin => {
                    this.adminData = admin
                    this.sidebarStatus = this.getSidebarStatus();
                },
                error => {
                }
            );
    }
    
    toHomePage() {
        // Redirect to desired URL                    
        if(this.devEnv.indexOf(this.hostName) !== -1){
            return window.location.href = 'http://services.eca.dev.nascorp.vn';
        }
        else if(this.testEnv.indexOf(this.hostName) !== -1){
            return window.location.href = 'http://services.eca.test.nascorp.vn';
        }
        else if(this.stagingEnv.indexOf(this.hostName) !== -1){
            return window.location.href = 'http://services.eca.uat.nascorp.vn';
        }
        else if(this.procEnv.indexOf(this.hostName) !== -1){
            return window.location.href = 'https://services.aisvietnam.com';
        }
        else{
            return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
        }
    }

    // Detect sidebar vibibility
    private getSidebarStatus() {
        return !this.adminData ? false : true;
    }
    
    private getHeaderName(moduleName: string): string {
        let headerName = "";

        switch(this.module) {
            case "camp":
                headerName = "Camp Programmes Management";
                break;
            case "asa":
                headerName = "Extra-Curricular Activities (ECAs) Management";
                break;
            case "bus":
                headerName = "Bus Management";
                break;
            case "reen":
                headerName = "Re-enrolment";
                break;
            case "conference":
                headerName = "Conference Booking System";
                break;
            default:
                break;
        }
        
        return headerName;
    }

    // Log our function
    private deleteSession() {
        // In case system login and booking for parent. Then, logout and login again with role parent to booking. We need to remove sessionStorage 
        if(this.module === 'conference') {
            window.sessionStorage.removeItem('info-parent-booking');
            window.sessionStorage.removeItem('interview-description');
        }
        this.sessionService.deleteAdminSession()
            .subscribe(
                complete => {
                    // Clear user session
                    this.adminService.clearAdminSessionData();
                    this.adminService.clearInterSession();
                    // Fire user session data changed event
                    this.adminService.adminDataChanged(null);
                    // Redirect to desired URL
                    if(this.devEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://auth.eca.dev.nascorp.vn/logout';
                    }
                    else if(this.testEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://auth.eca.test.nascorp.vn/logout';
                    }
                    else if(this.stagingEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://auth.eca.uat.nascorp.vn/logout';
                    }
                    else if(this.procEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'https://auth.aisvietnam.com/logout';
                    }
                    else{
                        return window.location.href = 'http://auth.local.eca.dev.nascorp.vn/logout';
                    }
                },
                error    => this.errorMessage = <any> error
            );
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/components/admin-header-auth/AdminHeaderAuthComponent.ts